export default {"src":"/_next/static/media/pillWithClock_40.7485eea6.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};